// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

const routes = [
  {
    path: '/',
    name: 'Home'
  },
  {
    path: '/news/0',
    name: 'News'
  },
  {
    path: '/projects',
    name: 'Projects'
  }
]

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: router,
  components: { App },
  template: '<App :pages="pages"/>',
  data: {
    pages: routes
  }
})



// WEBPACK FOOTER //
// ./src/main.js